import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';

import { ISnRadioFormFieldConfig } from '../../interfaces/radio-form-field-config.interface';
import {
  ISnRadioTemplateOptions,
  ISnRadioGroupTemplateOptions,
} from '../../interfaces/radio-template-options.interface';

@Component({
  selector: 'sn-radio-form-field',
  templateUrl: './radio.form-field.html',
  styleUrls: ['./radio.form-field.scss'],
})
export class SnRadioFormField extends FieldType<ISnRadioFormFieldConfig> {
  public readonly defaultOptions: ISnRadioFormFieldConfig = {
    type: 'radio',
    templateOptions: {
      floatLabel: 'always',
      inline: false,
      appearance: 'fill',
      hideFieldUnderline: true,
    },
  };

  constructor() {
    super();
  }

  get templateOptions(): ISnRadioTemplateOptions<any> | ISnRadioGroupTemplateOptions<any> {
    return this.field.templateOptions;
  }

  public onChange(index: number): void {
    if (this.templateOptions.change) {
      const option = this.templateOptions.options[index];

      this.templateOptions.change(this.field, option, this.model);
    }
  }

  public trackOption(index: number, item: { label: string; value: any }): any {
    return item.value;
  }
}
